<template>
  <div>
    <vs-row>
			<vs-col vs-type="flex" style="height: 105px;" vs-w="3" xs="12" class="p-1" >
				<statistics-card-line  icon="FilmIcon" icon-right :statistic="contents.total"
					statisticTitle="All Data" color="warning" />
			</vs-col>
			<vs-col vs-type="flex" style="height: 105px;" vs-w="3" class="p-1">
				<statistics-card-line icon="CheckIcon" icon-right :statistic="contents.exists"
					statisticTitle="Exists" color="success" />
			</vs-col>
			<vs-col vs-type="flex" style="height: 105px;" vs-w="3" class="p-1">
				<statistics-card-line icon="AlertCircleIcon" icon-right :statistic="contents.missing"
					statisticTitle="Missing" color="danger" />
			</vs-col>
			 
		</vs-row>
    <vs-table v-if="!loading" :data="contents.data" stripe>
         
         <template #thead>
             <vs-th>#</vs-th>
             <vs-th>Ar Title</vs-th>
             <vs-th>En Title</vs-th>
             <vs-th>year</vs-th>
             <vs-th>rating</vs-th>
             <vs-th>Exists</vs-th>
             <vs-th>Actions</vs-th>
         </template>
         <template slot-scope="{data}">
             <tbody>
                 <vs-tr v-for="(content,index) in data" :key="index">
                     <vs-td class="img-container">
                        {{index}}
                     </vs-td>
                     <vs-td>{{content.en_title}}</vs-td>
                     <vs-td>{{content.ar_title}}</vs-td>
                     <vs-td>{{content.year}}</vs-td>
                     <vs-td>{{content.rating}}</vs-td>
                     <vs-td >
                         <vs-chip v-if="!content.local_id" color="danger" >
                             Missing 
                         </vs-chip>
                         <vs-chip v-if="content.local_id" color="success"  >
                            Exists 
                         </vs-chip>
                     </vs-td>
                     <vs-td class="whitespace-no-wrap">
                         <!-- <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current"
                             @click="edit(story)" /> -->
                         <!-- <feather-icon :icon="story.status==1?'EyeOffIcon':'EyeIcon'" svgClasses="w-5 h-5 hover:text-danger stroke-current"
                             class="ml-2" @click="changeStatus(story)" />
                         <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current"
                             class="ml-2" @click="openConfirm(story)" /> -->
                     </vs-td>
                 </vs-tr>
             </tbody>
         </template>
     </vs-table>
     <vs-pagination :total="contents.last_page" v-model="page"></vs-pagination>
  </div>
</template>
<script>
	import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
export default {
    components:{StatisticsCardLine},
  data() {
    return {
      contents: [],
      loading: false,
      page:1
    };
  },
  created() {
    this.fetchContents()
  },
  watch:{
    page(){
        this.fetchContents() 
    }
  },
  methods: {
    fetchContents() {
      this.loading = true;
      this.axios.get(`${this.$apiUrl}/cin?page=${this.page}`).then((res) => {
        this.contents = res.data;
        this.loading = false;
      });
    },
  },
};
</script>